import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import './filters/filters';
import VueMarkdown from '@adapttive/vue-markdown';
import VueTour from 'vue-tour';
import i18n from '@/lang/i18n';
import VueQrcode from '@chenfengyuan/vue-qrcode';

import VueApexCharts from 'vue-apexcharts';

import './registerServiceWorker';
// Vue wait
import VueWait from 'vue-wait';
//VueCasl
import { abilitiesPlugin } from '@casl/vue';
import { ability } from './services/casl';
//Vue meta
import VueMeta from 'vue-meta';
import VueCountdown from '@chenfengyuan/vue-countdown';

Vue.use(VueApexCharts);

// Vue portals
// import PortalVue from 'portal-vue'
// Vue.use(PortalVue)

Vue.component('Apexchart', VueApexCharts);

Vue.component('QrCode', VueQrcode);
Vue.use(VueWait);
const wait = new VueWait({
  useVuex: true,
});

//VueTour
require('vue-tour/dist/vue-tour.css');
Vue.use(VueTour);

Vue.use(abilitiesPlugin, ability, { useGlobalProperties: true });

Vue.config.productionTip = false;

Vue.component('VueMarkdown', VueMarkdown);

Vue.use(VueMeta);

Vue.component(VueCountdown.name, VueCountdown);

router.beforeEach((to, from, next) => {
  if (store.getters.authenticatedUser === undefined) {
    // Deliberately not awaited - this guard has never blocked on the user and
    // making it do so would change navigation timing app-wide. Wrapping and
    // swallowing keeps a failed (or absent) /user call from throwing inside the
    // guard, which made vue-router abort the navigation to /login.
    Promise.resolve(store.dispatch('fetchAuthenticatedUser')).catch(() => {});
  }
  next();
});

new Vue({
  router,
  store,
  vuetify,
  i18n,
  wait,
  render: (h) => h(App),
}).$mount('#app');
